import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import adminReducer from "../Reducers/adminReducer";
import accountsReducer from "../Reducers/accountsReducer";
import disconnectWalletReducer from "../Reducers/disconnectWalletReducer";

const rootReducer = combineReducers({
  admin: adminReducer,
  accounts: accountsReducer,
  disconnectWallet: disconnectWalletReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
